import { useContext } from "react";
import {
  BaseSpaceConnectionContext,
  IBaseSpaceConnectionContext,
} from "@via/context/basespace-connection-context.tsx";

export function useBaseSpaceConnection(): IBaseSpaceConnectionContext {
  return useContext(BaseSpaceConnectionContext);
}
